<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('item.invest') }}
      </div>
    </div>
		
    <div class="items_3">
      <div class="item">
        <div class="item_div1">
          <p>
            {{ data.title }}
          </p>
          <!-- <p>每日可赚100.00</p> -->
        </div>
        <div class="item_img">
          <img :src="data.img">
        </div>
        <div class="item_div2">
          <div class="item_day">
            <p>{{ data.rate }} %</p>
            <p>{{ $t('investdetail.dayrate') }}</p>
          </div>
          <div class="item_day">
            <p>{{ $formatPen(data.min) }}</p>
            <p>{{ $t('investdetail.starting') }}</p>
          </div>
          <div class="item_min">
            <p><span>{{ data.day }}</span> {{ $t('investdetail.days') }}</p>
            <p>{{ $t('investdetail.cycle') }}</p>
          </div>
        </div>
				
        <div class="item_btn">
          <button
            v-if="data.percent<100"
            class="btn btn-block btn-outline btn-primary sub_btn"
            type="button"
            @click="$router.push('/doinvest/'+data.id)"
          >
            {{ $t('utils.invest') }}
          </button>
          <button
            v-if="data.percent>=100"
            class="btn btn-block btn-outline btn-primary sub_btn"
            type="button"
          >
            {{ $t('utils.investOver') }}
          </button>
        </div>
      </div>
      <div
        class="item_content"
        v-html="data.content"
      />
    </div>
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import { Progress,Dialog,Field } from 'vant';
	Vue.use(Progress).use(Dialog).use(Field);
	export default {
		name: "ItemDetail",
		data() {
			return {
				data: {},
				show_tz:false,
				number: "",
			};
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/item_detail', {
					id: this.$router.history.current.params.code
				}).then(res => {
					this.data = res.data;
				})
			},
			buy(item){
				this.show_tz = true;
			},
			confirm(){
				Fetch("/index/item_apply", {
				  id: this.data.id,
				  money:this.number
				}).then(r => {
				  if (r.data && r.data>0) {
					  this.$router.push("/invest/trx/"+r.data);
				  	// if(r.data<10000){
				  	// 	r.data = 10000;
				  	// }
				  	// Fetch('/user/recharge_type', {
				  	//   money: r.data,
				  	//   id:13
				  	// }).then((r) => {
				  	//     if(r.data.payment.payurl!=''){
				  	//       // window.open(r.data.payment.payurl,'_blank');
						 //  window.location.href = r.data.payment.payurl;
				  	//     }
				  	// });
				  } else {
				  	this.$router.push("/order");
				  }
				}).catch(err=>{
				    this.number = '';
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.red_top_bg {
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
		color: #FFFFFF;
	}

	.big_tit {
		left: 40px;
		width: 90%;
		color: #FFFFFF;
		transform: none;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.item_img{
		margin: 0;
		width: 100%;
		img{
			width: 100%;
		}
	}
	/deep/ .van-progress__pivot {
	  background-color: green;
	}
	/deep/ .van-progress__portion {
	  background: green;
	}
	.items_3 {
		margin: 50px 2% 0 2%;
		width: 96%;
		
		.item {
			background: #FFFFFF;
			margin-bottom: 10px;
			border-radius: 10px;
			div {
				margin: 5px 0;
			}

			.item_div1 {
				justify-content: space-between;
				border-bottom: 1px solid #ECECEC;
				padding: 15px 10px;
				display: block;
				p:nth-child(1) {
					font-weight: bold;
					line-height: 25px;
					font-size: 16px;
				}
				p:nth-child(2) {
					color: #999;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				font-size: 14px;
				
				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						font-weight: bold;
						color: #FF0000;

					}

					p:nth-child(2) {
						color: #999;
					}
				}

				.item_day {
					p:nth-child(1) {
						font-weight: bold;
					}

					p:nth-child(2) {
						color: #999;
					}
				}

				.item_min {
					p:nth-child(1) {
						font-weight: bold;

					}

					p:nth-child(2) {
						color: #999;
					}
				}
			}

			.item_div3 {
				color: #999;
				padding: 5px 10px;
			}

			.item_div4 {
				padding: 5px 10px;

				div:nth-child(1) {
					width: 100%;
					margin-top: 16px;
					margin-bottom: 10px;
				}
			}
			.item_btn {
				width: 70%;
				padding: 10px;
				margin-left: 15%;
				text-align: center;
				button {
					width: 50%;
					color: #FFFFFF;
					padding: 10px 5px;
					border-radius: 5px;
					// border: 1px solid #1989fa;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
		.item_content{
			background: #FFFFFF;
			padding: 10px;
			border-radius: 10px;
			line-height: 20px;
		}
	}
</style>
